import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'mydocma-mm-valid-tooltip',
  templateUrl: './valid-tooltip.component.html',
  styleUrls: ['./valid-tooltip.component.scss']
})
export class ValidTooltipComponent implements ITooltipAngularComp {

  public tooltip: string[];

  agInit(params: ITooltipParams): void {
    this.tooltip = params.value;

  }

  refresh(params: ITooltipParams): boolean {
    this.agInit(params);
    return true;
  }
}
